import React from 'react';
import { Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';
import { Outlet } from 'react-router-dom'; 

const Layout = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      
        
      }}
    >
      <Header />
      
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 3,
          display: 'flex',
          flexDirection: 'column',
          height: 'auto',
          // paddingTop:'10px'
          
        

        }}
      >
        <Box sx={{ flexGrow: 1, pl: 3 }}>
          <Outlet /> 
        </Box>
      </Box>
      
      <Footer />
    </Box>
  );
};

export default Layout;
